<template lang="pug">
  el-form(
    :model="form"
    v-loading="loadingForm"
    ref="AddUserForm"
    :rules="addUserFormRules"
    @submit.native.prevent
  )
    el-row.justify-center
      el-col(:span="24")
        .snooze-form
          .snooze-message.text-center
            | Change snooze upcoming 
            strong {{ snoozeNotification.info_type }}
            |  notifications for 
            strong {{ snoozeNotification.soil_sensor.transmitter_name }}
            |  ( 
            strong {{ snoozeNotification.soil_sensor.name }}
            | ) from 
            strong {{ snoozeNotification.soil_sensor.field_name }}
          
          SingleDateTimePicker.snooze-date(
            style="margin: auto;"
            v-model="form.ends_at"
            type="datetime"
            format="dd/MM/yyyy HH:mm"
            :value-format="'yyyy-MM-dd HH:mm:ss'"
            :reset-signal="resetKey"
            @onChange="handleEndsAtChange"
            @invalid="showDateError"
          )

    el-row.text-center
      el-button.dark-green-btn.pop-up-btn(
        @click="handleSendForm('AddUserForm')"
        :loading="loading"
      ) {{ $t('common.confirm') }}
</template>

<script>
import FilterDatePicker from "@components/_shared/FilterDatePicker";
import SingleDateTimePicker from "@components/_shared/SingleDateTimePicker";
import { mapActions, mapMutations, mapState } from "vuex";
import { customValidations } from "@utils/customValidators";
import { usersViewValidations } from "@utils/formValidations/usersViewValidations";
import { setObjectValues } from "@utils/generalUtils";
import _ from "lodash";

export default {
  name: "EditSnoozeNotification",
  mixins: [usersViewValidations, customValidations],

  components: {
    FilterDatePicker,
    SingleDateTimePicker
  },

  data() {
    return {
      selectedPlaceID: null,
      foundPlacesByPin: [],
      form: {
        soil_sensor_id: null,
        info_type: null,
        ends_at: null
      },
      sites: [],
      roles: [],
      dateRange: [],

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60000; // disables dates/times before current minute
        }
      },

      loading: false,
      loadingForm: false,
      setObjectValues,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),

    ...mapState("map", ["changedDialog"]),
    ...mapState("snoozeNotification", ["snoozeNotification"]),


  },

  created() {
    this.loadingForm = true;
    this.handleGetFormData();
    this.loadingForm = false;
  },

  async mounted() {

  },

  methods: {
    ...mapActions("snoozeNotification", ["updateSnoozeNotification"]),
    ...mapActions("site", ["getSites"]),
    ...mapActions("role", ["getRoles"]),

    ...mapMutations("dialog", ["hideEditSnoozeNotificationDialog"]),

    ...mapMutations("snoozeNotification", [ "setShouldFetchSnoozeNotifications" ]),

    async handleChange(values) {
      this.transmitterInfos = [];
      this.loadingStatistics = true;

      let computedParams = `?by_sensor_transmitter_id=${this.transmitter.id}`;
      if (values && values.length > 0) {
        let dateRangeComputed = {
          start_date: values[0],
          end_date: values[1],
        };

        computedParams += `&by_date_range[start_date]=${dateRangeComputed.start_date}&by_date_range[end_date]=${dateRangeComputed.end_date}`;
        this.dateRange = [dateRangeComputed.start_date, dateRangeComputed.end_date];
        
        const response = await this.getSensorTransmitterInfo(computedParams);
        this.transmitterInfos = response;
      } 
      else {
        this.transmitterInfos = [];
      }
    this.loadingStatistics = false;

    },

    handleGetFormData() {
      if (!this.snoozeNotification) return false;
      // this.form = { ...this.customer }; 
      this.form.soil_sensor_id = this.snoozeNotification.soil_sensor_id;
      this.form.info_type = this.snoozeNotification.info_type;
    },

    clearForm() {
      this.setObjectValues(this.form, "");
    },

    async handleSendForm(formName) {
      this.loading = true;
      const form = this.$refs[formName];
      this.setShouldFetchSnoozeNotifications(false);

      if (!this.snoozeNotification) return false;

      // Check if ends_at is present
      if (!this.form.ends_at) {
        this.$message.error("Please select a date and time.");
        this.loading = false;
        return;
      }

      if (!this.form.ends_at || new Date(this.form.ends_at).getTime() <= Date.now()) {
        this.$message.error("Please select a future date and time.");
        this.loading = false;
        return;
      }

      const payload = {
        id: this.snoozeNotification.id,
        // info_type: this.form.info_type,
        // soil_sensor_id: this.form.soil_sensor_id,
        ends_at: this.formatDateUTC(this.form.ends_at)
      };

      try {
        await this.updateSnoozeNotification(payload);
        this.hideEditSnoozeNotificationDialog();
        this.clearForm();
        this.setShouldFetchSnoozeNotifications(true);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }

    },

    formatDateUTC(date) {
      const pad = (n) => (n < 10 ? '0' + n : n);
      return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate()) +
        ' ' +
        pad(date.getUTCHours()) +
        ':' +
        pad(date.getUTCMinutes()) +
        ':' +
        pad(date.getUTCSeconds())
      );
    }

  },
};
</script>

<style lang="scss" scoped>
.snooze-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;

  .snooze-message {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    margin-bottom: 10px;
  }

}

.pop-up-btn {
  width: 140px;
  height: 40px;
  font-weight: bold;
  border-radius: 20px;
}
</style>